// @flow

import routes from 'app/member-home/routes';

export default {
  routes,
};
